import React from 'react';
import './UserManagementList.scss';
import { GET_USERS, GET_CONFIG } from '../../service/types';
import {
  showLoadingModal,
  hideModal,
  showCustomJSXModal
} from '../../service/actions/modal';
import {
  createLoadingSelector,
  createErrorMessageSelector
} from '../../service/selectors';
import {
  showSidePanel,
  hideSidePanel,
  updateTrapFocus
} from '../../service/actions/sidePanel';
import { mainViewComponent } from '../common/HOCs';
import { connect } from 'react-redux';
import UserRolesModal from './UserRolesModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { getUsers } from '../../service/actions/users';

class UsersList extends React.Component {
  componentDidMount() {
    // Only fetch users if user has appropriate scope
    if (
      this.props.scopes &&
      this.props.scopes.includes('faculty-member.notes.write')
    ) {
      this.props.getUsers();
    }
  }

  openUserRolesModal = user => {
    this.props.showCustomJSXModal(
      <UserRolesModal
        key={user.username}
        user={user}
        hideModal={this.props.hideModal}
      />
    );
  };

  render() {
    const { users, loading, errorMessage, scopes, history } = this.props;
    // If user does not have permission, redirect to /unauthorized
    if (!scopes || !scopes.includes('faculty-member.notes.write')) {
      if (history && typeof history.replace === 'function') {
        history.replace('/unauthorized');
        return null;
      }
      window.location.assign('/unauthorized');
      return null;
    }
    const sortedUsers =
      users && users.list
        ? [...users.list].sort((a, b) => a.lastName.localeCompare(b.lastName))
        : [];
    const showUsers = users && users.list && users.list.length > 0;

    return (
      <div className="user-management-list">
        <h1>Users</h1>
        <div className="location-results">
          {/* Only render table or empty/error message when not loading; spinner handled by modal */}
          {!loading && (
            <>
              <table className="user-management-items">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {showUsers &&
                    sortedUsers.map(user => (
                      <tr
                        key={user.username}
                        onClick={() => this.openUserRolesModal(user)}
                      >
                        <td></td>
                        <td>
                          {user.lastName}, {user.firstName}
                        </td>
                        <td>{user.username}</td>
                        <td>{user.email}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!showUsers && (
                <div
                  className={
                    errorMessage
                      ? 'error-message users-error-message'
                      : 'empty-message users-empty-message'
                  }
                >
                  {errorMessage ? (
                    <span className="error-pill">
                      <FontAwesomeIcon
                        icon={faExclamationCircle}
                        style={{ marginRight: '0.5em' }}
                      />
                      {errorMessage}
                    </span>
                  ) : (
                    'No users found.'
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

const loadingSelector = createLoadingSelector([GET_USERS, GET_CONFIG]);
const errorSelector = createErrorMessageSelector([GET_USERS]);
const mapStateToProps = state => {
  console.log('mapStateToProps state: ', state);
  const { auth, users, config } = state;
  console.log('users: ', users);

  return {
    scopes: auth.scopes,
    loading: loadingSelector(state),
    errorMessage: errorSelector(state),
    users: users,
    typeList: config && config.config && config.config.locationTypes
  };
};

const mainViewConfig = {
  pageTitle: 'Users'
};

// export default UsersList
export default connect(mapStateToProps, {
  showLoadingModal,
  hideModal,
  showCustomJSXModal,
  showSidePanel,
  hideSidePanel,
  updateTrapFocus,
  getUsers
})(mainViewComponent({ component: UsersList, mainViewConfig }));
